export default function mapIcon(className) {
  return (
    <image
      width="18"
      height="15"
      className={className}
      viewBox="0 0 18 15"
      fill="none"
      xlinkHref="https://alumni.media.mit.edu/~deva/dataglen/dg2.jpg"
    ></image>
  );
}
